module.exports = __webpack_public_path__ + "static/media/bussiness3.f80f1531.png";